import { FC } from 'react';

import config from '@ui-furniture/config';
import Ga from '@ui-furniture/ui/snippets/googleAnalytics';

const { gaId } = config.analytics;

export const GoogleAnalytics: FC = () => <Ga id={gaId} />;
